__turbopack_context__.v({
  "className": "barlow_condensed_da705f98-module__88jwPa__className",
  "variable": "barlow_condensed_da705f98-module__88jwPa__variable",
});
